<template>
  <v-dialog :model-value="show" @update:model-value="$emit('update:show', $event)" max-width="900px">
    <v-card>
      <v-card-title>
        GIG Project Information
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          class="mx-4"
        ></v-text-field>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="gigProjects"
          :search="search"
          :items-per-page="10"
          :page="page"
          hide-default-footer
          class="elevation-1"
          :loading="loading"
        >
          <template #[`item.actions`]="{ item }">
            <v-btn small text color="primary" @click="selectProject(item)">Select</v-btn>
          </template>
        </v-data-table>
        <div class="d-flex justify-center pt-4">
          <v-pagination
            v-model="page"
            :length="Math.ceil(gigProjects.length / 10)"
            :total-visible="7"
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'GIGProjectGridModal',
  props: {
    show: Boolean,
  },
  emits: ['close', 'select', 'update:show'],
  setup(props, { emit }) {
    const store = useStore()
    const loading = ref(false)
    const search = ref('')
    const page = ref(1)

    const headers = [
      { text: 'Project Name', value: 'prjct_nm' },
      { text: 'PM', value: 'PM_NM' },
      { text: 'Start Date', value: 'prjct_st_ymd' },
      { text: 'End Date', value: 'prjct_end_ymd' },
      { text: 'Actions', value: 'actions', sortable: false },
    ]

    const gigProjects = computed(() => store.getters['project/allProjects'])

    const close = () => {
      emit('update:show', false)
      emit('close')
    }

    const selectProject = (project) => {
      emit('select', project)
      close()
    }

    return {
      headers,
      gigProjects,
      loading,
      search,
      page,
      close,
      selectProject,
    }
  }
}
</script>

<style scoped>
.v-data-table {
  width: 100%;
}
</style>
